<template>
  <orderPage :type="'customer-in'"></orderPage>
</template>

<script>
import orderPage from "../order-template/index.vue";
export default {
  name: "customerInt",
  components: {
    orderPage
  },
  methods: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
